import PropTypes from "prop-types"
import DetailsSelectionHOC from "./details_selection_hoc"
import CategoriesSelectorContent from "./categories_selector_content"
import UsersStats from "../users/user_stats"
import EngagementStats from "../engagement/engagement_stats"
import TopServicesBasic from "../top_services/basic"
import TopPublishedApplets from "../top_published_applets/top_published_applets"
import TopCategoriesContainer from "../top_categories/top_categories_container"
import { categoryTopPublishedAppletsQuery } from "../top_published_applets/top_published_applets_fetcher"
import { categoryTopPublishedAppletsMapper } from "../top_published_applets/gql_data_mapper"
import {
  categoryUserMetricsQuery,
  categoriesMapper,
} from "../users/user_metrics_fetcher"

const CategoriesPage = props => {
  const PeriodWrapped = ({ selection, ...props }) => {
    if (selection.data.id != -1) {
      const userProps = {
        ...props,
        metrics: [
          "new_users_all_time",
          "active_users_all_time",
          "users_with_an_applet_run_daily",
        ],
        categoryName: selection.data.name,
        query: categoryUserMetricsQuery,
        mapper: categoriesMapper,
        subHeaderText: `Adoption metrics for users connecting %CATEGORY_NAME% services to %SERVICE_NAME%`,
        headerSeparator: false,
      }

      const engagementProps = {
        ...props,
        categoryName: selection.data.name,
        subHeaderText: `From users connecting %CATEGORY_NAME% services to %SERVICE_NAME%`,
        headerSeparator: false,
      }

      const topServicesProps = {
        ...props,
        categoryName: selection.data.name,
        subHeaderText: `The top %CATEGORY_NAME% services connected to %SERVICE_NAME%`,
        headerSeparator: false,
      }

      const topAppletsProps = {
        ...props,
        categoryName: selection.data.name,
        mapper: categoryTopPublishedAppletsMapper,
        query: categoryTopPublishedAppletsQuery,
        subHeaderText: `The top %CATEGORY_NAME% to %SERVICE_NAME% Applets`,
      }

      return (
        <div>
          <UsersStats {...userProps} />
          <EngagementStats {...engagementProps} />
          <TopServicesBasic {...topServicesProps} />
          <TopPublishedApplets {...topAppletsProps} />
        </div>
      )
    } else {
      const categoriesProps = {
        ...props,
        subHeaderText: `Top service categories connected to %SERVICE_NAME%`,
      }
      return <TopCategoriesContainer {...categoriesProps} />
    }
  }

  const CategoryContent = (categoryName, currentMetricDate) => (
    <CategoriesSelectorContent
      serviceName={props.serviceName}
      serviceModuleName={props.serviceModuleName}
      categoryName={categoryName}
      currentMetricDate={currentMetricDate}
    />
  )

  const CategoriesContainer = DetailsSelectionHOC({
    WrappedComponent: PeriodWrapped,
    options: [
      {
        data: {
          id: -1,
          name: "All",
        },
        ContentComponent: CategoryContent,
      },
    ].concat(
      props.items.map(category => {
        return {
          ...category,
          ContentComponent: CategoryContent,
        }
      })
    ),
    rootUrl: "categories",
    serviceTitle: props.serviceName,
    serviceColor: props.serviceColor,
    serviceImage: props.serviceImage,
    initialSelection: props.initialCategory
      ? props.items.find(i => i.data.name == props.initialCategory)
      : null,
  })

  return <CategoriesContainer {...props} />
}

CategoriesPage.propTypes = {
  items: PropTypes.array,
  serviceName: PropTypes.string,
  serviceModuleName: PropTypes.string,
  serviceColor: PropTypes.string,
  serviceImage: PropTypes.string,
  initialCategory: PropTypes.string,
  servicesUrl: PropTypes.string,
}

export default CategoriesPage
